//login
export const LOGIN = "/auth/login"
export const AUTH_PROFILE = "/auth/profile"
export const AUTH_LOGOUT = "/auth/logout"
export const CHANGE_PASSWORD = "/auth/change-password"
export const REGISTER = "/register"
export const REGISTER_USER = "/user"

//REGISTER
export const VERIFY_EMAIL = "/auth/signup/initiate"
export const VERIFY_CODE = "/auth/signup/verify"
export const SET_PASSWORD = "/auth/signup/set-password"
export const POST_FAKE_REGISTER = "/post-fake-register"

//RESET
export const VERIFY_RESET_EMAIL = "/password-reset/initiate"
export const VERIFY_RESET_CODE = "/password-reset/verify-code"
export const SET_RESET_PASSWORD = "/password-reset/reset"
export const SET_PASSWORD_WITH_TOKEN = "/password-reset/set-with-token"

//USERS
export const USERS = "/admin/users"
export const GET_DOMAINS = "/admin/domains"
export const BLACKLIST = "/admin/blacklist";
export const DISTRIBUTOR_WHITELIST = "/admin/distributor-whitelist";

//COMPENIES
export const COMPANIES = "/admin/companies"

// DOCUMENTS (Admin + Me)
export const ADMIN_DOCUMENTS = "/admin/documents"                
export const ADMIN_DOCUMENT = "/admin/documents"                
export const COMPANY_DOCUMENTS = "/admin/companies"              
export const ME_DOCUMENTS = "/me/documents"                     
export const ASSIGN_DOCUMENT_COMPANIES = "/admin/documents"  

// DASHBOARD
export const GET_DASHBOARD_DATA = "/admin/dashboard/summary"
export const GET_DASHBOARD_SIGNUPS = "/admin/dashboard/signups"
export const GET_DASHBOARD_DOCUMENTS_MONTHLY = "/admin/dashboard/documents-monthly"
export const GET_DASHBOARD_COMPANY_TYPES = "/admin/dashboard/company-users"
export const GET_DASHBOARD_DAILY_DOCUMENTS = "/admin/dashboard/daily-documents"

// USER (ME)
export const GET_ME_DASHBOARD_SUMMARY = "/me/dashboard/summary";
export const GET_ME_DASHBOARD_DAILY_DOCS = "/me/dashboard/daily-documents";
export const GET_ME_DASHBOARD_DOCS_MONTHLY = "/me/dashboard/documents-monthly";
export const GET_ME_DASHBOARD_TOP_TYPES = "/me/dashboard/top-types";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//ASSESSMENTS
export const GET_ASSESSMENTS = "/assessment"
export const ADD_ASSESSMENT = "/assessment"
export const ASSESSMENT = "/assessment"

//RESIDENT ASSESSMENTS
export const GET_RESIDENT_ASSESSMENTS = "/resident-assessment"
export const ADD_RESIDENT_ASSESSMENT = "/resident-assessment"
export const RESIDENT_ASSESSMENT = "/resident-assessment"

// PCH ASSESSMENTS
export const PCH_ASSESSMENTS = "/pch"
export const CLONE_ASSESSMENT = "/assessment/clone"
export const CLONE_CAREPLAN = "/resident-assessment/clone"


// PATIENTS
export const GET_PATIENTS = "/patients"
export const ADD_NEW_PATIENT = "/patients"
export const UPDATE_PATIENT = "/patients"
export const DELETE_PATIENT = "/patients"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_MAILS_LIST = "/mailslists"
export const SELECT_FOLDER = "/folders"
export const GET_SELECTED_MAILS = "/selectedmails"
export const SET_FOLDER_SELECTED_MAILS = "/setfolderonmail"
export const UPDATE_MAIL = "/update/mail"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"
export const DELETE_MESSAGE = "/delete/message"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"
export const GET_CRYPTO_PRODUCTS = "/crypto-products"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

// JOBS
export const GET_JOB_LIST = "/jobs"
export const ADD_NEW_JOB_LIST = "/add/job"
export const UPDATE_JOB_LIST = "/update/job"
export const DELETE_JOB_LIST = "/delete/job"

//Apply Jobs
export const GET_APPLY_JOB = "/jobApply"
export const DELETE_APPLY_JOB = "add/applyjob"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"
export const DELETE_KANBAN = "/delete/tasks"
export const ADD_CARD_DATA = "/add/tasks"
export const UPDATE_CARD_DATA = "/update/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"

//Blog
export const GET_VISITOR_DATA = "/visitor-data"

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data"
export const GET_YEARLY_DATA = "/yearly-data"
export const GET_MONTHLY_DATA = "/monthly-data"

export const TOP_SELLING_DATA = "/top-selling-data"

//dashboard crypto
export const GET_WALLET_DATA = "/wallet-balance-data"

//dashboard jobs
export const GET_STATISTICS_DATA = "/Statistics-data"

export const GET_EARNING_DATA = "/earning-charts-data"

export const GET_PRODUCT_COMMENTS = "/comments-product"

export const ON_LIKNE_COMMENT = "/comments-product-action"

export const ON_ADD_REPLY = "/comments-product-add-reply"

export const ON_ADD_COMMENT = "/comments-product-add-comment"

export const ADMIN_MUST_READ = "/admin/must-read"
export const ME_MUST_READ = "/me/must-read"
